import {
  LearnerBusinessId,
  ReplacementFilesComponentDocumentsDto,
  ReplacementFilesComponentLearnersDto,
  ReplacementFilesComponentsDto,
} from '@cambridgeassessment/lib-ee-commons';
import {
  EntriesActionTypes,
  RESET_ENTRIES_LIST,
  SET_IS_LOADING_LEARNERS,
  UPDATE_LEARNERS_RESUBMISSION_STATUS,
  ADD_COMPONENTS,
  ADD_COMPONENT_LEARNERS,
  SET_IS_LOADING_COMPONENTS,
  ADD_COMPONENT_DOCUMENTS,
  UPDATE_DOCUMENTS_RESUBMISSION_STATUS,
  SET_IS_SAVING_RESUBMISSION_STATUS,
  COMPONENT_RESUBMITTION_SUCCESS,
  COMPONENT_RESUBMISSION_STATUS_UPDATED_SUCCESS,
  SET_IS_LINKED_CANDIDATE_MODAL_OPEN,
  UPDATE_ASSOCIATED_LEARNERS,
  SET_SELECTED_LEARNER,
} from './types';

export const resetEntriesList = (): EntriesActionTypes => ({
  type: RESET_ENTRIES_LIST,
});

export const setIsLoadingLearners = (componentIndex: number, isLoadingEntries: boolean): EntriesActionTypes => ({
  type: SET_IS_LOADING_LEARNERS,
  payload: { componentIndex, isLoadingEntries },
});

export const setIsLoadingComponents = (isLoadingComponents: boolean): EntriesActionTypes => ({
  type: SET_IS_LOADING_COMPONENTS,
  payload: { isLoadingComponents },
});

export const updateLearnersResubmissionStatus = (
  entryIndex: number,
  componentIndex: number,
  availableForResubmission: boolean,
  associatedLearners: LearnerBusinessId[],
): EntriesActionTypes => ({
  type: UPDATE_LEARNERS_RESUBMISSION_STATUS,
  payload: {
    entryIndex,
    componentIndex,
    availableForResubmission,
    associatedLearners,
  },
});

export const updateAssociatedLearners = (associatedLearners: LearnerBusinessId[]): EntriesActionTypes => ({
  type: UPDATE_ASSOCIATED_LEARNERS,
  payload: {
    associatedLearners,
  },
});

export const setSelectedLearner = (selectedLearner: {
  learnerBid: ReplacementFilesComponentLearnersDto;
  entryIndex: number;
  componentIndex: number;
  val: boolean;
}): EntriesActionTypes => ({
  type: SET_SELECTED_LEARNER,
  payload: {
    selectedLearner,
  },
});

export const updateDocumentsResubmissionStatus = (
  componentIndex: number,
  documentId: ReplacementFilesComponentDocumentsDto['section']['id'],
  availableForResubmission: boolean,
): EntriesActionTypes => ({
  type: UPDATE_DOCUMENTS_RESUBMISSION_STATUS,
  payload: {
    componentIndex,
    documentId,
    availableForResubmission,
  },
});

export const componentResubmissionSuccess = (
  componentIndex: number,
  availableForResubmission: boolean,
): EntriesActionTypes => ({
  type: COMPONENT_RESUBMITTION_SUCCESS,
  payload: {
    componentIndex,
    availableForResubmission,
  },
});

export const componentResubmissionStatusUpdatedSuccess = ({
  componentIndex,
  isAllSelected,
  isAllAbsent,
}: {
  componentIndex: number;
  isAllSelected: boolean;
  isAllAbsent: boolean;
}): EntriesActionTypes => ({
  type: COMPONENT_RESUBMISSION_STATUS_UPDATED_SUCCESS,
  payload: {
    componentIndex,
    isAllSelected,
    isAllAbsent,
  },
});

export const addComponents = (components: ReplacementFilesComponentsDto[]): EntriesActionTypes => ({
  type: ADD_COMPONENTS,
  payload: { components },
});

export const addComponentLearners = (
  componentIndex: number,
  entries: ReplacementFilesComponentLearnersDto[],
  nextUrl?: string,
): EntriesActionTypes => ({
  type: ADD_COMPONENT_LEARNERS,
  payload: { componentIndex, entries, nextUrl },
});

export const addComponentDocuments = (
  componentIndex: number,
  documents: ReplacementFilesComponentDocumentsDto[],
): EntriesActionTypes => ({
  type: ADD_COMPONENT_DOCUMENTS,
  payload: { componentIndex, documents },
});

export const setIsSavingResubmissionStatus = (isSaving: boolean): EntriesActionTypes => ({
  type: SET_IS_SAVING_RESUBMISSION_STATUS,
  payload: { isSaving },
});

export const setIsLinkedCandidateModalOpen = (setOpen: boolean): EntriesActionTypes => ({
  type: SET_IS_LINKED_CANDIDATE_MODAL_OPEN,
  payload: { setOpen },
});
